var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-header'),_c('div',{staticStyle:{"min-height":"calc(100vh - 100px)","padding-top":"0px","padding-bottom":"30px","background-color":"#f9f9f9"}},[_c('router-view'),_c('v-bottom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }